import React from "react";

export function ListViewIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40.87 18.27"
      width="30"
      height="20"
      fill="white"
      {...props}
    >
      <rect
        className="cls-1"
        x="0"
        y="15.78"
        width="30.83"
        height="2.49"
        rx="1.24"
        ry="1.24"
      />
      <rect
        className="cls-1"
        x="0"
        y="10.52"
        width="40.6"
        height="2.49"
        rx="1.24"
        ry="1.24"
      />
      <rect
        className="cls-1"
        x="0"
        y="5.26"
        width="35.85"
        height="2.49"
        rx="1.24"
        ry="1.24"
      />
      <rect
        className="cls-1"
        x="0"
        y="0"
        width="40.87"
        height="2.49"
        rx="1.24"
        ry="1.24"
      />
    </svg>
  );
}
